<template>
    <div class="analytics_item">
        <h5 class="analytics_item-title">{{ title }}</h5>
        <kernel-chart
            :data-array="population"
            :target-value="target"
            :height="180"
            :margin-right="10"
            :margin-left="10"
            :margin-bottom="20"
            :margin-top="0"
        />
        <div class="analytics_item-details">
            <span class="analytics_item-details-line">
                Assessed
            </span>
            <span class="analytics_item-details-line">
                {{ displayedTarget }}
            </span>
            <span class="analytics_item-details-line">Median</span>
            <span class="analytics_item-details-line">
                {{ median }}
            </span>
            <span class="analytics_item-details-line">Average</span>
            <span class="analytics_item-details-line">
                {{ mean }}
            </span>
            <span class="analytics_item-details-line">
                Deviance
            </span>
            <span class="analytics_item-details-line">
                {{ deviance }}
            </span>
            <span class="analytics_item-details-percentile">% = {{ percentile }}</span>
        </div>
    </div>
</template>
<script>
import KernelChart from '@/apps/Valuation/components/ValuerTool/elements/KernelChart.vue'

export default {
    name: 'AnalyticsItem',
    components: {
        KernelChart,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        population: {
            type: Array,
            required: true,
        },
        target: {
            type: Number,
            required: true,
        },
        assessed: {
            type: String,
            default: null,
        },
        median: {
            type: String,
            required: true,
        },
        mean: {
            type: String,
            required: true,
        },
        deviance: {
            type: String,
            required: true,
        },
        percentile: {
            type: String,
            required: true,
        },
    },
    computed: {
        displayedTarget() {
            if (this.assessed === null) return this.target
            return this.assessed
        },
    },
}
</script>
<style lang="scss" scoped>
.analytics_item {
    padding: 24px;
    background: white;

    &-title {
        color: #001837;
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 16px;
    }

    &-details {
        margin-top: 16px;
        display: grid;
        width: 100%;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr;
        gap: 8px 0;
        justify-items: start;

        &-line {
            color: #798da6;
            font-size: 14px;
            font-weight: 500;

            &:nth-child(2n) {
                color: #001837;
                justify-self: end;
            }
        }

        &-percentile {
            grid-column: 1 / -1;
            justify-self: end;
            color: #001837;
            font-size: 18px;
            font-weight: 700;
            line-height: normal;
        }
    }
}
</style>
